/*
 * "All collections" sheet (snippets/jc-collections-sheet.liquid).
 * - Opens from any [data-jc-sheet-open] link (falls back to /collections without JS)
 * - Loads its content once via the Section Rendering API, prefetched on pointerdown/hover,
 *   cached in sessionStorage per locale
 * - Filter field, close on Esc / backdrop / close button / swipe down on the handle
 */
(function () {
  if (window.jcSheetReady) return;
  window.jcSheetReady = true;

  var dialog = document.querySelector('[data-jc-sheet]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var body = dialog.querySelector('[data-jc-sheet-body]');
  var panel = dialog.querySelector('.jc-sheet__panel');
  var filter = dialog.querySelector('[data-jc-sheet-filter]');
  var url = dialog.dataset.url;
  var cacheKey = 'jc_sheet_v1_' + (document.documentElement.lang || '') + '_' + url;
  var loading = null;
  var lastTrigger = null;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load() {
    if (loading) return loading;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) return (loading = Promise.resolve(cached));
    } catch (e) {}
    loading = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('.jc-sheet__content');
        var out = content ? content.outerHTML : '';
        try { sessionStorage.setItem(cacheKey, out); } catch (e) {}
        return out;
      })
      .catch(function () { loading = null; return ''; });
    return loading;
  }

  function render() {
    if (body.dataset.loaded) return;
    load().then(function (html) {
      if (!html) {
        window.location.href = (window.routes && routes.collections_url) || '/collections';
        return;
      }
      body.innerHTML = html;
      body.dataset.loaded = '1';
      applyFilter();
    });
  }

  function open(trigger) {
    lastTrigger = trigger || null;
    render();
    dialog.showModal();
    // Focus the panel itself: no focus ring on the close button, no keyboard popping up on phones.
    panel.focus({ preventScroll: true });
    document.documentElement.classList.add('jc-sheet-open');
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });
  }

  function close() {
    if (!dialog.open) return;
    dialog.classList.remove('is-open');
    document.documentElement.classList.remove('jc-sheet-open');
    var done = function () {
      dialog.close();
      dialog.querySelector('.jc-sheet__panel').style.transform = '';
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
    };
    if (reduceMotion) done(); else setTimeout(done, 260);
  }

  function applyFilter() {
    var q = (filter.value || '').trim().toLowerCase();
    var items = body.querySelectorAll('[data-jc-sheet-item]');
    var shown = 0;
    items.forEach(function (a) {
      var match = !q || (a.dataset.name || '').indexOf(q) !== -1;
      a.parentElement.hidden = !match;
      if (match) shown++;
    });
    body.querySelectorAll('.jc-sheet__label').forEach(function (label) {
      var list = label.nextElementSibling;
      label.hidden = !!q && list && !list.querySelector('li:not([hidden])');
    });
    var empty = body.querySelector('[data-jc-sheet-empty]');
    if (empty) empty.hidden = shown > 0 || !q;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-jc-sheet-open]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  // Prefetch as soon as the visitor reaches for a trigger.
  ['pointerdown', 'mouseover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest && event.target.closest('[data-jc-sheet-open]')) load();
    }, { passive: true });
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || event.target.closest('[data-jc-sheet-close]')) close();
  });
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    close();
  });
  filter.addEventListener('input', applyFilter);
  // In a search field Escape only clears the text; close the sheet when it is already empty.
  filter.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !filter.value) {
      event.preventDefault();
      close();
    }
  });

  // Swipe down on the handle closes the sheet (phones).
  var handle = dialog.querySelector('[data-jc-sheet-handle]');
  var startY = null;
  handle.addEventListener('pointerdown', function (event) {
    startY = event.clientY;
    handle.setPointerCapture(event.pointerId);
  });
  handle.addEventListener('pointermove', function (event) {
    if (startY === null) return;
    var dy = Math.max(0, event.clientY - startY);
    panel.style.transition = 'none';
    panel.style.transform = 'translateY(' + dy + 'px)';
  });
  handle.addEventListener('pointerup', function (event) {
    if (startY === null) return;
    var dy = event.clientY - startY;
    startY = null;
    panel.style.transition = '';
    if (dy > 90) close();
    else panel.style.transform = '';
  });
})();
